import React from 'react';
import {
    createSavedFilterConfig,
    getDisplayFilters,
    getGroupedFilters
} from '../../production/helpers/savedFiltersUtils';
import { useBrowserOrAccountLocale } from '../hooks/useBrowserOrAccountLocale';
import { Filter, SavedFilterModalProps } from '../types/savedFilters';
import SavePreferenceModal from './SavePreferenceModal';

export default function SaveFilterModal({
    open,
    onClose,
    onSave,
    appliedFilters,
    isLoading = false,
    facets = [],
    isEdit = false,
    initialData
}: SavedFilterModalProps) {
    const locale = useBrowserOrAccountLocale();
    const filtersByIdentifier = getGroupedFilters(getDisplayFilters(appliedFilters), locale);
    const savedFilterConfig = createSavedFilterConfig(filtersByIdentifier, facets, true, isEdit);

    const handleSave = async (data: {
        name: string;
        description: string;
        shared: boolean;
        pinAsTab?: boolean;
        data: Filter[];
    }) => {
        await onSave({
            name: data.name,
            description: data.description,
            shared: data.shared,
            pinAsTab: data.pinAsTab
        });
    };

    return (
        <SavePreferenceModal
            open={open}
            onClose={onClose}
            onSave={handleSave}
            data={appliedFilters}
            isLoading={isLoading}
            config={savedFilterConfig}
            initialData={initialData}
        />
    );
}
